<div class="d-grid gap-3" style="grid-template-columns: repeat(auto-fill, minmax(300px, 1fr))">
  <app-automation-grid-card
    *ngFor="let automation of items; trackBy: trackBy"
    [automation]="automation"
    (click)="edit.emit(automation)"
  ></app-automation-grid-card>
</div>
